export default __webpack_public_path__ + "static/media/image-work-company-w@3x.2af84eff.png";